import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const sections = [
    {
        title: 'About JectHub',
        description: 'JectHub is an innovative online platform designed to bridge the gap between theoretical knowledge and practical experience in Artificial Intelligence, Machine Learning, Cybersecurity, and Data Science. It provides students with hands-on projects, challenges, and mentorship to enhance their skills and career readiness.',
    },
    {
        title: 'Mission',
        description: 'To empower students and professionals by providing a collaborative learning environment that fosters innovation, hands-on experience, and mentorship in AI, Cybersecurity, and Data Science.',
    },
    {
        title: 'Vision',
        description: 'To become the "GitHub of AI Education" for Africa, fostering a community-driven platform for learning and collaboration, connecting students to industry opportunities and bridging the skills gap in emerging technologies.',
    },
    {
        title: 'Core Values',
        description: 'Innovation, Collaboration, Excellence, Integrity, and Impact. We strive to create a learning ecosystem that nurtures talent and drives technological advancements.',
    },
    {
        title: 'Why Choose JectHub?',
        description: 'JectHub offers real-world projects, expert mentorship, career guidance, and a supportive community to help learners excel in AI, Cybersecurity, and Data Science. Our platform is designed to connect students with global opportunities and enhance their employability.',
    },
    {
        title: 'Tuition-Free Model',
        description: 'By offering free AI, Machine Learning, Cybersecurity, and Data Science programs, JectHub is addressing a critical gap in accessible tech education in Africa.',
    },
    {
        title: 'Focus on Underprivileged Students',
        description: 'Targeting marginalized communities ensures inclusivity and empowers individuals who might otherwise lack opportunities in the tech sector.',
    },
    {
        title: 'Bridging the Skills Gap',
        description: 'Africa’s tech ecosystem is growing rapidly, but a lack of skilled professionals remains a barrier. JectHub is directly tackling this issue.',
    },
];

function WhyJectHub() {
    return (
        <Layout>
            <Content style={{ padding: '50px' }}>
                <Title level={2}>Why JectHub?</Title>
                <Row gutter={[16, 16]}>
                    {sections.map((section, index) => (
                        <Col xs={24} sm={12} md={12} lg={8} key={index}>
                            <Card title={section.title} bordered={false}>
                                <Paragraph>{section.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
}

export default WhyJectHub;
